import React from 'react';
import styled, { css } from 'styled-components';
import { minBp } from 'src/lib/theme';

export const Wrap = styled.div`
  width: 260px;
  background-color: white;
  display: flex;
  flex-direction: column;

  @media ${minBp('desktop')} {
    width: 100%;

    &:not(:last-of-type) {
      margin-bottom: 20px;
    }
  }
`;

export const Tag = styled.div`
  background-color: #efefef;
  padding: 5px;
  border-radius: 4px 4px 0px 0px;
  position: absolute;
  bottom: 0;
  left: 25px;
  height: 23px;
  font-size: 10px;
  color: #2a2a2a;
`;

export const Image = styled.div`
  ${({ bgImage }) => `
    position: relative;
    padding-top: 53.08%;
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
    background-image: url("${bgImage}");
  `}
`;

export const Content = styled.div`
  padding: 12px;
  display: flex;
  flex-direction: column;
  flex: 1;

  @media ${minBp('tablet')} {
    height: 100px;
  }

  @media ${minBp('tabletLarge')} {
    padding: 24px;
    height: 176px;
  }

  @media ${minBp('desktop')} {
    height: auto;
  }

  @media screen and (-ms-high-contrast: active), screen and (-ms-high-contrast: none) {
    min-height: 175px;
  }
`;

export const Name = styled.h4`
  font-family: ${({ theme }) => theme.fonts.dinDemi};
  font-weight: 500;
  font-size: 12px;
  text-transform: uppercase;
  margin: 0 0 2px;
  flex: 1;

  @media ${minBp('tabletLarge')} {
    font-size: 17px;
    margin: 0 0 6px;
  }
`;

export const TotalWrap = styled.div`
  display: flex;
  align-items: center;

  svg {
    vertical-align: middle;
    height: 11px;
    width: 10px;
    margin-right: 4px;
    position: relative;
    bottom: 4px;

    path {
      fill: #2a2a2a;
    }
  }

  @media ${minBp('tabletLarge')} {
    svg {
      bottom: 7px;
      width: 11px;
      height: 13px;
    }
  }
`;

export const TotalStyles = css`
  font-size: 10px;
  padding-right: 7px;
  border-right: 1px solid #b7b7b7;
  margin-bottom: 7px;

  @media ${minBp('tabletLarge')} {
    margin-bottom: 13px;
    font-size: 14px;
  }
`;

export const Price = styled.span`
  ${TotalStyles}
  margin-right: 7px;
  line-height: 1;
`;

export const Fitting = styled.span`
  ${TotalStyles}
  padding-right: 0;
  border-right: 0;
`;
